import modelBase from '../../models/model-base.model';
import loginModel from '../login.model';
import modelBaseV2 from '../../models/model-base-v2.model';

var userModel = {
  initCredentials: function () {
    userModel.newUser = {};
  },

  getUserList: function (successCallBack, failureCallBack, filter) {
    var params = {};
    params.sortBy = "";
    params.orderBy = "";
    params.pageIndex = filter.pageIndex;
    params.pageSize = filter.pageSize;
    params.userName = filter.userName;
    params.userID = filter.userID;
    params.userRoleCode = filter.userRoleCode;
    params.statusCode = filter.statusCode;
    params.userType = filter.userType;
    params.division = filter.divisionGroup;
    params.startDate = filter.updateDateFrom;
    params.endDate = filter.updateDateTo;
    params.siteCode = filter.siteCode;
    params.siteGroupID = filter.siteGroupID;
    params.userUDF = filter.userUDF;

    modelBase.post(successCallBack, failureCallBack, '/api/user/list', { body: params });
  },

  downloadUserList: function (successCallBack, failureCallBack, filter, fileName) {
    var params = {};
    params.sortBy = "";
    params.orderBy = "";
    params.pageIndex = "0";
    params.pageSize = "0";
    params.userID = filter.userID;
    params.userName = filter.userName;
    params.userRoleCode = filter.userRoleCode;
    params.statusCode = filter.statusCode;
    params.userType = filter.userType;
    params.division = filter.divisionGroup;
    params.startDate = filter.updateDateFrom;
    params.endDate = filter.updateDateTo;
    params.userUDF = filter.userUDF;

    modelBase.postDownload(successCallBack, failureCallBack, '/api/user/list/download', { body: params }, fileName + ".xlsx");
  },

  createUser: function (successCallBack, failureCallBack, params) {
    modelBase.post(successCallBack, failureCallBack, '/api/user', { body: params });
  },

  editInfo: function (successCallBack, failureCallBack, params) {
    modelBase.post(successCallBack, failureCallBack, '/api/user/editInfo', { body: params });
  },

  editMap: function (successCallBack, failureCallBack, params, _userId) {
    modelBase.post(successCallBack, failureCallBack, '/api/user/editMap?' + 'userId=' + _userId, { body: params });
  },

  editMapV2: function (body, userId) {
    return modelBaseV2.post('/api/user/editMap', { body, params: { userId } });
  },

  editUdf: function (successCallBack, failureCallBack, params, _userId) {
    modelBase.post(successCallBack, failureCallBack, '/api/user/editUserUDF?' + 'userId=' + _userId, { body: params });
  },

  getUserDetails: function (successCallBack, failureCallBack, encryptedUserId) {
    const qs = modelBase.toQueryString({ userID: encryptedUserId });
    modelBase.get(successCallBack, failureCallBack, '/api/user?' + qs);
  },

  getUserDetailsV2: function (encryptedUserId) {
    return modelBaseV2.get('/api/user', { params: { userID: encryptedUserId } });
  },

  checkUserID: function (successCallBack, failureCallBack, loginID, token) {
    var path = '/api/user/exist/userid/' + loginID;
    modelBase.get(successCallBack, failureCallBack, path);
  },

  checkUserEmail: function (successCallBack, failureCallBack, email, token) {
    var path = '/api/user/exist/email/' + email;
    modelBase.get(successCallBack, failureCallBack, path);
  },

  getUDFData: function (successCallBack, failureCallBack, user) {
    var path = '/api/user/getUserUDF?userId=' + user;
    modelBase.get(successCallBack, failureCallBack, path);
  },

  userResetPassword: function (successCallBack, failureCallBack, userID, newpassword, token) {
    var params = {}
    params.userID = userID
    params.newPassword = newpassword

    modelBase.post(successCallBack, failureCallBack, '/api/user/resetpassword', { body: params });
  },

  exportToExcel: function (successCallBack, failureCallBack, filter, fileName) {
    var params = {};
    var path = '/api/user/export?' + 'LoginIDOrName=' + filter.LoginIDOrName
      + '&UserRoleCode=' + filter.UserRoleCode
      + '&StatusCode=' + filter.UserStatusCode

    modelBase.getDownload(successCallBack, failureCallBack, path, params, fileName + ".xlsx");
  },

  getUserListBySupervisor: function () {
    return new Promise((resolve, reject) => {
      modelBase.get(data => {
        resolve(data);
      }, error => {
        return reject(error);
      }, `/api/user/userListBySupervisor?userId=${loginModel.credentials.userID}`);
    });
  },

  getUserListByExcel: function (formData) {
    return new Promise((resolve, reject) => {
      modelBase.post(
        data => {
          resolve(data);
        }, error => {
          return reject(error);
        },
        '/api/user/excelUpload',
        { body: formData }
      );
    });
  },
  uploadExcelForBatchRegistration: function (formData) {
    return modelBaseV2.postDownload('/api/user/batchregistrationexcel', { body: formData }, "batchRegistrationExcelResult.xlsx");
  },
  downloadTemplateExcelForBatchRegistration: function () {
    return modelBaseV2.getDownload('/api/user/batchRegistrationExcelTemplate', null, "batchRegistrationExcelTemplate.xlsx");
  },

  getBackDateLimitDate: () => {
    return modelBaseV2.get('/api/user/backDateLimitDate');
  },
  getCommonAgreements: (countryCode) => {
    return modelBaseV2.getPublic('/api/user/getCommonAgreements?countryCode=' + countryCode);
  },
}

export default userModel;